import { ChangeEvent, useState } from 'react';

import Button from 'components/Button/Button';
import Input from 'components/Input/Input';

import { FreeSearchProps } from './types';

export const FreeSearch = ({
  label,
  onApply,
  initialValue,
  minLength,
  maxLength
}: FreeSearchProps) => {
  const [value, setValue] = useState(initialValue || '');

  const hasInput = value.length > 0;
  const isBelowMinLength = hasInput && value.length < (minLength || 0);
  const isAboveMaxLength = hasInput && value.length > (maxLength || Infinity);
  const isApplyDisabled = isBelowMinLength || isAboveMaxLength;

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    setValue(event.target.value.trim());
  };

  const handleApply = () => {
    onApply(value);
  };

  return (
    <div className="flex flex-col p-3 gap-4 rounded-md ">
      <div className="text-p-s font-medium text-base-foreground">{label}</div>
      <div>
        <Input
          placeholder="Search"
          value={value}
          maxLength={maxLength}
          onChange={handleChange}
          className="w-full border-none shadow-none outline-none h-9 focus:ring-0 focus:border-none active:ring-0 active:border-none focus-visible:ring-0 focus-visible:border-none"
        />
      </div>
      <Button onClick={handleApply} variant="outline" disabled={isApplyDisabled}>
        Apply
      </Button>
    </div>
  );
};
